import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Tooltip } from "@mui/material";

const LinkTemplate = (props) => {
  const formatWebsiteUrl = (url) => {
    if (!url) return null;

    // If domains array exists, use the first domain
    if (!url && props?.domains?.length > 0) {
      url = props.domains[0];
    }

    if (!url) return null;

    // Remove any whitespace
    url = url.trim();

    // Add https:// if no protocol is specified
    if (!url.match(/^https?:\/\//i)) {
      url = `https://${url}`;
    }

    return url;
  };

  const websiteUrl = formatWebsiteUrl(props?.website);

  if (!websiteUrl) {
    return <span style={{ color: "#666" }}>No website</span>;
  }

  return (
    <Tooltip title={`Visit ${websiteUrl}`} arrow>
      <a
        href={websiteUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: "#1976d2",
          fontWeight: 500,
          transition: "color 0.2s ease",
          ":hover": {
            color: "#115293",
          },
        }}
      >
        {props.website || props.domains?.[0]}
        <OpenInNewIcon style={{ fontSize: 16, marginLeft: 2 }} />
      </a>
    </Tooltip>
  );
};

export default LinkTemplate;
